"use client";

import Image from "next/image";
import { type CSSProperties } from "react";

import { cn } from "@/lib/utils";

interface ZomMarkProps {
  /** "light" = black mark for light surfaces; "dark" = white mark for dark surfaces. */
  variant?: "light" | "dark" | "theme";
  size?: number;
  /** Empty text marks the image decorative when nearby text names Zom. */
  alt?: string;
  className?: string;
}

type ZomMarkRuntimeStyle = CSSProperties & { "--zom-mark-size": string };

function zomMarkStyle(size: number): ZomMarkRuntimeStyle {
  return { "--zom-mark-size": `${size}px` };
}

const SRC: Record<"light" | "dark", string> = {
  light: "/zom-logo-dark.png",
  dark: "/zom-logo-light.png",
};

export function ZomMark({
  variant = "light",
  size = 24,
  alt = "Zom",
  className,
}: ZomMarkProps) {
  if (variant === "theme") {
    return (
      <span
        className={cn(
          "relative inline-block size-[var(--zom-mark-size)]",
          className,
        )}
        style={zomMarkStyle(size)}
      >
        <Image
          src={SRC.light}
          alt={alt}
          width={size}
          height={size}
          className="fc-mark-theme-light block h-[var(--zom-mark-size)] w-auto"
          priority
        />
        <Image
          src={SRC.dark}
          alt={alt}
          width={size}
          height={size}
          className="fc-mark-theme-dark hidden h-[var(--zom-mark-size)] w-auto"
          priority
        />
      </span>
    );
  }

  return (
    <Image
      src={SRC[variant]}
      alt={alt}
      width={size}
      height={size}
      className={cn("block h-[var(--zom-mark-size)] w-auto", className)}
      style={zomMarkStyle(size)}
      priority
    />
  );
}
